import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IReportsRefferalCustomerDetailing_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IReportsRefferalCustomerDetailing_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  KuikaB2B_ShipmentSalesCustomerDetailMobile: any[];
  KuikaB2B_ShipmentSalesCustomerDetailMobile_dummy: any[];
}

export class ReportsRefferalCustomerDetailing_ScreenBase extends React.PureComponent<
  IReportsRefferalCustomerDetailing_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  reportsrefferalcustomerdetailing_624937_value_kuikaTableRef: React.RefObject<any>;
  reportsrefferalcustomerdetailing_439926_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 654370,
          PropertyName: "value",
          Value: "Sevk Raporu Detay",
          TagName: "Label5_value",
        },
        {
          Id: 107900,
          PropertyName: "value",
          Value: "Koleksiyon Adı",
          TagName: "Label9_value",
        },
        {
          Id: 931071,
          PropertyName: "value",
          Value: "Desen Adı",
          TagName: "Label11_value",
        },
        {
          Id: 974894,
          PropertyName: "value",
          Value: "Ebat Adı",
          TagName: "Label13_value",
        },
        {
          Id: 10427,
          PropertyName: "value",
          Value: "Miktar",
          TagName: "Label15_value",
        },
        {
          Id: 859206,
          PropertyName: "value",
          Value: "Metrekare",
          TagName: "Label21_value",
        },
        {
          Id: 884902,
          PropertyName: "value",
          Value: "Bekleyen Miktar",
          TagName: "Label23_value",
        },
        {
          Id: 806590,
          PropertyName: "value",
          Value: "Bekleyen Metrekare",
          TagName: "Label25_value",
        },
        {
          Id: 475970,
          PropertyName: "value",
          Value: "Sevk Edilen Miktar",
          TagName: "Label27_value",
        },
        {
          Id: 738366,
          PropertyName: "value",
          Value: "Sevk Edilen Metrekare",
          TagName: "Label29_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 654370,
          PropertyName: "value",
          Value: "Shipment Report Detail",
          TagName: "Label5_value",
        },
        {
          Id: 107900,
          PropertyName: "value",
          Value: "Collection Name",
          TagName: "Label9_value",
        },
        {
          Id: 931071,
          PropertyName: "value",
          Value: "Pattern Name",
          TagName: "Label11_value",
        },
        {
          Id: 974894,
          PropertyName: "value",
          Value: "Size Name",
          TagName: "Label13_value",
        },
        {
          Id: 10427,
          PropertyName: "value",
          Value: "Quantity",
          TagName: "Label15_value",
        },
        {
          Id: 859206,
          PropertyName: "value",
          Value: "Square meters",
          TagName: "Label21_value",
        },
        {
          Id: 884902,
          PropertyName: "value",
          Value: "Pending Quantity",
          TagName: "Label23_value",
        },
        {
          Id: 806590,
          PropertyName: "value",
          Value: "Pending Square Meters",
          TagName: "Label25_value",
        },
        {
          Id: 475970,
          PropertyName: "value",
          Value: "Quantity Shipped",
          TagName: "Label27_value",
        },
        {
          Id: 738366,
          PropertyName: "value",
          Value: "Square Meters Shipped",
          TagName: "Label29_value",
        },
      ],
    },
    {
      Id: "0ab2e0f1-a9e0-45e0-ba26-48ad240a888b",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 654370, PropertyName: "value", Value: "Sevk Raporu Detay" },
        { Id: 249813, PropertyName: "title", Value: "Title" },
        { Id: 107900, PropertyName: "value", Value: "Koleksiyon Adı" },
        {
          Id: 298883,
          PropertyName: "value",
          Value: "[datafield:productatt03desc]",
        },
        { Id: 931071, PropertyName: "value", Value: "Desen Adı" },
        {
          Id: 495593,
          PropertyName: "value",
          Value: "[datafield:productatt05desc]",
        },
        { Id: 974894, PropertyName: "value", Value: "Ebat Adı" },
        {
          Id: 416078,
          PropertyName: "value",
          Value: "[datafield:productatt07desc]",
        },
        { Id: 10427, PropertyName: "value", Value: "Miktar" },
        { Id: 631919, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 859206, PropertyName: "value", Value: "Metrekare" },
        { Id: 709916, PropertyName: "value", Value: "[datafield:qty2]" },
        { Id: 884902, PropertyName: "value", Value: "Bekleyen Miktar" },
        { Id: 185965, PropertyName: "value", Value: "[datafield:returnqty1]" },
        { Id: 806590, PropertyName: "value", Value: "Bekleyen Metrekare" },
        { Id: 546919, PropertyName: "value", Value: "[datafield:returnqty2]" },
        { Id: 475970, PropertyName: "value", Value: "Sevk Edilen Miktar" },
        { Id: 814316, PropertyName: "value", Value: "[datafield:netqty1]" },
        { Id: 738366, PropertyName: "value", Value: "Sevk Edilen Metrekare" },
        { Id: 861151, PropertyName: "value", Value: "[datafield:netqty2]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.reportsrefferalcustomerdetailing_624937_value_kuikaTableRef =
      React.createRef();
    this.reportsrefferalcustomerdetailing_439926_value_kuikaPaginationRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      B2BGetRolesById: [],
      KuikaB2B_ShipmentSalesCustomerDetailMobile: [],
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "reportsrefferalcustomerdetailing",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.ReportsRefferalCustomerDetailingPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.ReportsRefferalCustomerDetailingPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsrefferalcustomerdetailing",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "reportsrefferalcustomerdetailing",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.ReportsRefferalCustomerDetailingPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.ReportsRefferalCustomerDetailingPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  ReportsRefferalCustomerDetailingPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      ShippingNumberWS_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ShippingNumber ??
          this.props.screenInputs.shippingnumber,
        "string"
      ),
      PageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsRefferalCustomerDetailing/ReportsRefferalCustomerDetailingPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile =
      result?.data.kuikaB2B_ShipmentSalesCustomerDetailMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsRefferalCustomerDetailingPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsRefferalCustomerDetailingPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile ??
      this.state.KuikaB2B_ShipmentSalesCustomerDetailMobile;
    formVars.reportsrefferalcustomerdetailing_439926_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile !== undefined
          ? stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile?.length > 0
            ? stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile[0].totalRows
            : null
          : this.state.KuikaB2B_ShipmentSalesCustomerDetailMobile?.length > 0
          ? this.state.KuikaB2B_ShipmentSalesCustomerDetailMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  ReportsRefferalCustomerDetailingComponent_532644_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  ReportsRefferalCustomerDetailingComponent_439926_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ShippingNumberWS_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ShippingNumber ??
          this.props.screenInputs.shippingnumber,
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "reportsrefferalcustomerdetailing_439926_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "ReportsRefferalCustomerDetailing/ReportsRefferalCustomerDetailingComponent_439926_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile =
      result?.data.kuikaB2B_ShipmentSalesCustomerDetailMobile;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.ReportsRefferalCustomerDetailingComponent_439926_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  ReportsRefferalCustomerDetailingComponent_439926_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_624937 =
      stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile ??
      this.state.KuikaB2B_ShipmentSalesCustomerDetailMobile;
    formVars.reportsrefferalcustomerdetailing_439926_total =
      ReactSystemFunctions.value(
        this,
        stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile !== undefined
          ? stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile?.length > 0
            ? stateVars.KuikaB2B_ShipmentSalesCustomerDetailMobile[0].totalRows
            : null
          : this.state.KuikaB2B_ShipmentSalesCustomerDetailMobile?.length > 0
          ? this.state.KuikaB2B_ShipmentSalesCustomerDetailMobile[0].totalRows
          : null
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.ReportsRefferalCustomerDetailingPageInit();
    }
  }
}
